import { LEVEL_TO_CYCLE } from '@monecolier/types';

/**
 * STU-02 — seul le collège (6ème à 3ème) ouvre droit à un compte Espace Élève,
 * même règle que le serveur (apps/api/src/lib/studentAccount.ts). Accepte une
 * chaîne brute (`requestedLevel` n'est pas typé plus finement côté client) et
 * répond `false` pour toute valeur inconnue.
 */
export function isCollegeLevel(level: string): boolean {
  return (LEVEL_TO_CYCLE as Record<string, string | undefined>)[level] === 'COLLEGE';
}
